import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  position: fixed;
  inset: 0;
  z-index: 9999;

  background-color: rgb(211 228 255 /70%);
  backdrop-filter: blur(4px);

  animation: entering 0.5s forwards;

  &.modal-difficulty-price--hide{
    animation: exiting 0.5s forwards;
  }
`;

export const ModalContainer = styled.article`
  width: 95%;
  max-width: 33.25rem;
  padding: 3rem 2.25rem 3.5rem;

  font-family: 'Axiforma';

  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;

  border-radius: 17px;
  background-color: #fff;
  box-shadow: 0 3px 6px rgba(0,0,0,0.16);

  gap: 2rem;

  .modal-difficulty-price__title {
    font-size: 1.75rem;
    color: var(--blue00);
    font-weight: bold;

    line-height: 1.15;

    text-align: center;
  }

  .modal-difficulty-price__question {
    font-size: 1.5rem;
    color: var(--blue00);
  }

  .modal-difficulty-price__prefix-input-container {
    display: flex;
    align-items: center;

    width: 100%;
    min-height: 3.875rem;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

    border-radius: 1.75rem;
    padding: 0 2rem;

    &:focus-within {
      outline: 2px solid var(--grayad);
    }
  }

  .modal-difficulty-price__currency-prefix {
    font-size: 1.25rem;
    font-weight: 400;

    color: var(--grayad);
  }

  .modal-difficulty-price__input {
    background: transparent;
    border: none;
    outline: none;

    margin-left: 0.25rem;

    font-size: 1.25rem;
    font-weight: 400;
    flex: 1;

    color: var(--grayad);
  }

  .modal-difficulty-price__button {
    text-transform: none;
    font-weight: normal;
    letter-spacing: 0;
    font-size: 1.25rem;
    min-height: 3.75rem;
  }
`
